/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];[_nghost-%COMP%]{padding:1.5rem 3rem;display:block;margin:0 auto}@media (max-width:544px){[_nghost-%COMP%]{padding:1.5rem 1rem}}@media (min-width:1050px){.cc-container[_nghost-%COMP%]{max-width:940px}}@media (min-width:1200px){.cc-container[_nghost-%COMP%]{max-width:1300px}}"];
export { styles as styles };
